import Helper from "../core/helper/helper";
import PaymentService from "../core/services/payment.service";
import { PaymentMethodLabel, PaymentStateLabel } from "../core/types";

export default class Labels {
  // SERVER
  static server = {};

  // Config
  static loaderMessage = "Bem-vindo! A carregar...";
  static companyNameAuto = "CheckPoint®";
  static companyNameTech = "ClickStop®";
  static poweredByText = "Conheça esta App em";
  static appLink = "www.keymaster.pt";

  // Lite Version
  static liteGenericMessage(is_scheduler_solo = false) {
    return is_scheduler_solo ?
      `Registe-se agora para aceder a todos os seus serviços contratados!
      Aceda ao seu Histórico, realize Marcações,
      envie Feedback, altere os dados da sua conta
      e muito mais!`
      : `Registe-se agora para aceder a todos os seus serviços contratados!
      Aceda ao seu Histórico, Faturas, realize Marcações,
      envie Feedback, altere os dados da sua conta
      e muito mais!`;
  }
  
  static liteLinkAppMessage =
    "Instale já a App Keymaster Cliente no seu equipamento Android através deste link:";
  static liteScheduleTitle = "Deseja aceder às suas Marcações?";
  static liteProgressTitle = "Deseja aceder aos seus Serviços em curso?";
  static liteHistoryTitle = "Deseja aceder ao seu Histórico?";
  static liteSidebarScheduleTitle = "Deseja criar uma nova marcação?";
  static liteSidebarEquipmentsTitle = "Deseja aceder aos seus itens?";
  static liteSidebarProfileTitle = "Deseja editar o seu perfil?";
  static liteSidebarMenuKey = "Deseja aceder aos seus serviços noutros prestadores?";
  static liteSendFeedbackTitle = "Deseja dar feedback sobre este serviço?";
  static liteSendInvoiceTitle = "Deseja receber as faturas no e-mail?";
  static liteApproveBudgetTitle = "Deseja aprovar orçamentos?";
  static liteUploadMediaTitle = "Deseja adicionar fotos e vídeos?";
  static liteSeeMediaTitle = "Deseja ver fotos e vídeos?";
  static liteSeeFileTitle = "Deseja ver documentos?";
  static liteUploadFileTitle = "Deseja adicionar documentos?";
  static liteWelcomeMessage = {
    text1: "Gestores, Colaboradores e Clientes numa só App!",
    text2: "O seu software de gestão de serviços.",
  };

  static menuTitles = {
    profile: "Perfil e Configurações Pessoais",
    companies: "Empresas & Prestadores de Serviço",
    equipment: "Os seus XPTOs",
  }

  // Login
  static login = {
    header: 'Keymaster Cliente Login',
    passwordRecovery: 'Recuperar password',
    linkMessage: 'Não tem conta? Registe-se agora!',
  };
  static register = {
    header: 'Keymaster Cliente Registo de Utilizador',
    linkMessage: 'Já tenho conta. Quero entrar agora!',
  }
  static passwordRecovery = {
    header: 'Recuperar Password',
    message: 'Envie-nos o e-mail associado à sua conta e receba uma nova password no seu e-mail!',
    submitButton: 'Enviar e-mail',
    linkMessage: 'Sabe a sua password? Entrar agora',
  }
  static sentEmail = {
    header: "Pedido de Recuperação de Password Enviado",
    message: "Consulte na sua Caixa de Entrada, o e-mail para recuperar a password.",
    linkMessage: "Voltar à Página de Início",
  };
  static emailConfirmation = {
    header: "Confirmação de E-mail",
  };
  static newPassword = {
    header: "Alterar Password",
  };
  static appFeedback = {
    header: "Feedback da App",
    message:
      "Gostou de utilizar a nossa App? Deixe por favor os seus comentarios e sugestões:",
  };

  // Buttons
  static button = {
    registerButton: "Registar",
    liteRegisterButton: "Registar-me",
    sendButton: "Enviar",
    notNowButton: "Agora Não",
    loginButton: "Iniciar Sessão",
    approveBudget: "Aprovar Orçamento",
    confirm: "Confirmar",
    cancel: "cancel",
    uploadMediaButton: "Adicionar foto/vídeo",
    uploadDocumentButton: "Adicionar documento",
  };

  // Sidebar / Navbar
  static sidebarScheduleMessage = (company = "") => {
    return {
      title: "Brevemente",
      intro: "Em breve, poderá fazer aqui as suas marcações. ",
      message: "Actualmente para marcar um serviço, entre em contacto com a $Company, por favor.".replace(
        "$Company",
        company
      ),
      generalMessage: "Agradecemos desde já a sua compreensão, e pedimos desculpa pelo incómodo.",
      oldAppointmentsLink: "Marcações Antigas",
      fullScheduleDesactivated: "Função desativada pela $company".replace("$company", company),
      selectCompany: "Selecione o Prestador de Serviços para fazer uma marcação:",
    };
  };
  static sidebarCompanies = {
    message: "Empresas & Prestadores de Serviço",
    addCompanyLabel: "+ Adicionar Prestadora de Serviços",
    backButtonText: "Ver os meus Prestadores de Serviço",
    searchInputPlaceholder: "Pesquisar novo Prestador",
    addCompanyLinkText: "Adicionar",
    tabs: {
      categories: "Categorias",
      companies: "+ Prestadores",
    },
    categorySection: {
      instruction: "Selecione a categoria de serviços que deseja ver:",
    },
    companyDetails: {
      authenticationTitle: () =>
        "Deseja acompanhar os serviços do prestador ",
      termsChangedTitle: () =>
        "Foi atualizada a política de privacidade do prestador ",
      authenticationMessage:
        "Registe-se agora para aceder a todos os detalhes do seus serviços contratados! Aceda ao seu Histórico, a Faturas, realize Marcações, envie Feedback, altere os dados da sua conta e muito mais!",
      registerButton: "Registar agora",
      cancelButton: "Agora não!",
      loginButton: "Iniciar Sessão",
      adicionar: "Continuar",//"Adicionar agora",
      entrar: "Entrar agora"
    },
  };

  // Items/details Service
  static resetItemDetailsText = "Tem a certeza que pretende repor os detalhes originais?";
  static emptyItemList = "Sem itens na sua lista";
  static errorEmptyItems = "Não foi possivel aceder à sua lista de itens";
  static emptyGalleryMessage = "Sem Fotos/Vídeos Disponíveis";
  static emptyFilesMessage = "Sem Ficheiros/Documentos Disponíveis";
  static equipmentDetailsTitle = (itemLabel) =>
    `Detalhes de $itemLabel`.replace("$itemLabel", itemLabel);
  static updateItemImage = (itemLabel) =>
    `Imagem de $itemLabel atualizada com sucesso`.replace("$itemLabel", itemLabel);
  static equipmentWaiting = "Aguardando que chegue a loja.";
  static resetItemSpecs = (itemLabel) =>
    `Repor Detalhes de $itemLabel`.replace("$itemLabel", itemLabel);
  static selectItemTypeSpecLabel = "Selecione o tipo de equipamento";

  static emptyEquipments1 = (itemLabel, itemPronoun) =>
    `Ainda não tem ${itemPronoun} ${itemLabel.toLowerCase()} na sua App.`;
  static emptyEquipments2 = (itemLabel, itemPronoun) => `Para poder realizar marcações deve adicionar pelo menos ${itemPronoun} ${itemLabel.toLowerCase()}.`;
  static chooseEquipment = (itemLabel, itemPronoun) => `Selecione ${itemPronoun} ${itemLabel.toLowerCase()} para marcar:`;
  static equipmentTitle = (itemLabel, itemPronoun1, itemPronoun2) => {
    if (Helper.patientVertical.includes(Helper.vertical())) {
        return `${Helper.itemLabel()}s`;
      } else {
        return `${itemPronoun1}s ${itemPronoun2}s ${itemLabel.toLowerCase()}s`;
      }
  }

  // Services
  static errorLoadServices =
    "Não foi possível obter serviços neste estado. \nTente novamente dentro de momentos. \nObrigado.";
  static noServices = {
    active: "Sem serviços em curso!",
    scheduled: "Sem marcações pendentes!",
    completed: "Sem serviços concluídos!",
  };
  static schedulers = {
    newscheduler: "Nova marcação ",
  };
  static noServicesMessage = (company) =>
    "Por favor disponibilize o seu e-mail ao prestador de serviços $company, para que seja introduzido na sua ficha de cliente e possamos dar-lhe acesso aos seus dados.".replace(
      "$company",
      company
    );
  static totalDiscount = "Total descontos aplicados";
  static servicesCommentLabel = "Comentários sobre o serviço:";
  static servicesCommentHistoryLabel = "Histórico de Comentários sobre o serviço:";
  static servicesClientCommentLabel = ""; //"Deixe-nos os seus comentários/observações sobre o serviço, se necessário, reponderemos à sua questão:";
  static servicesInternalCommentLabel =
    "Escreva notas pessoais, lembranças suas, o que desejar… (só você pode ver):";
  static swiper = {
    slide1: "Em Curso",
    slide2: "Marcações",
    slide3: "Histórico",
  };
  static counterMessages = {
    companyname: "{{companyname}}",
    services: "Serviços em Curso {{companyname}}:",
    noservices: "Sem Serviços em Curso {{companyname}}",
    noservicesScheduler: "Não disponível neste prestador",
    schedulers: "Marcações Pendentes {{companyname}}:",
    noschedulers: "Sem Marcações Pendentes {{companyname}}",
    classification: "Serviço{{plural}} Pendente{{plural}} de Pontuar",
    noclassification: "Sem Serviços Pendentes de Pontuar",
    noservicesclassification: "Sem Serviços {{companyname}} concluídos",
  }

  // Authentication
  static authenticateUserError403Text =
    "Confirme os seus dados ou faça o registo do seu e-mail. Obrigado.";
  static sendConfirmEmailInfo = {
    title: "E-mail enviado com sucesso",
    text_1: "Poderá demorar alguns minutos",
    text_2: "a receber o e-mail que foi enviado para",
    link_1: "Se já carregou no link do e-mail enviado, ",
    link_2: "Não recebeu nenhum e-mail, envie de novo!",
  };
  static emailAssociatedMesssage =
    'O e-mail inserido já se encontra associado a uma conta, caso o registo não esteja concluído click em "Confirmar" para ser reenviado um e-mail de confirmação';

  // Validations
  static profileContactNumberError = 'Não pode inserir números de contacto repetidos.';
  static profileInvalidContactNumber = 'Número de contacto Inválido.';
  static profileInvalidLicenseNumber = 'Matrícula inserida Inválida.';
  static passwordPatternError = 'A password deve ter pelo menos 8 caracteres e ser uma combinação de letras em maiúsculas, letras minúsculas, números e símbolos.';
  static emailPatternError = 'Por favor insira um formato de endereço de e-mail correto. Ex: utilizador@mail.com';
  static emptyContactError = 'Tem que adicionar pelo menos um contacto.';
  static profileInvalidEmail = 'E-mail inválido.';
  static profileInvalidNIF = 'O NIF introduzido não é válido.';
  static invalidZipCode = 'O Código Postal não é válido para Portugal. \nVerifique o formato: 1234-567.';
  static readTermsConditionsError = 'Tem que aceitar os termos e condições';
  static requiredField = 'Campo obrigatório!';
  static changesOnProfileMessage = 'Existem alterações de perfil para guardar, tem a certeza que pretende sair da página?';
  
  // Generic Error
  static genericErrorTitle = "Pedido sem sucesso";
  static genericErrorMessage =
    "Foi encontrado um problema durante o pedido, por favor tente mais tarde";
  static registedErrorTitle = "Registado sem sucesso";
  static invoiceErrorMessage = "Lamentamos mas não é possível aceder a esta fatura neste momento.";

  // Generic Success
  static registedSuccessTitle = "Registado com sucesso";

  // Confirmations
  static confirmRemoveItem = "Tem a certeza que pretende eliminar este item?";
  static confirmUpdatePassword = "Tem a certeza que pretende atualizar a password?";
  static confirmProfileChanges = "Tem a certeza que pretende guardar as alterações de perfil?";
  static confirmServiceCancel = "Tem a certeza que pretende cancelar este serviço?";
  static confirmSendInvoice =
    "A fatura será enviada para os endereços de e-mail definidos na área de Perfil.";
  static confirmRemoveFile = "Tem a certeza que pretende remover este ficheiro?";
  static confirmSendInvoiceButton = "Enviar fatura para o meu e-mail";
  static confirmApproveBudgetTitle = "Aprovação do Orçamento";
  static confirmApproveBudget = (valor) =>
    "Caso pretenda avançar com o Orçamento no valor de $Valor€ Total c/IVA, carregue em Confirmar.".replace(
      "$Valor",
      valor
    );
  static warningSendInvoiceMessage =
    'Para que possamos proceder ao envio da Fatura, por favor ative o e-mail de envio em "Editar Perfil".';
  static confirmChanges = "Guardar Alterações";
  static exitEdit = "Sair Modo Edição";

  // Generic Props
  static undefinedDate = "Por definir";
  static estimatedDate = "Data estimada";

  // Feedback
  static feedbackTitle = "OBRIGADO!";
  static feedbackMessage = "Pontue o nosso serviço e deixe-nos os seus comentários, por favor:";

  // Route Titles
  static servicesPage = "Serviços";
  static serviceDetailsPage = "Detalhes do Serviço";
  static equipmentDetailsPage = "Detalhes do Equipamento";
  static profilePage = "Dados do Cliente";
  static feedbackPage = "Feedback";
  static paymentPage = "Pagamento"

  // Terms & Conditions
  static termsConditionsLinkText = "Li e concordo com os ";
  static termsConditionsLink = "termos de uso.";
  static termsConditionsTitle = "Termos & Condições";
  static termsConditionsAuto =
    "O cliente autoriza os sintomas contratados e ainda a circulação exterior do veículo, por motivo de recepção, entrega, diagnóstico, experiência e ensaio, facultando a documentação do veiculo para o efeito, sob pena de eventuais multas serem da sua inteira responsabilidade. O veículo deverá ser levantado no prazo máximo de 48 horas após a reparação, ou passa a ser devida indemnização por espaço ocupado, no valor de 50.00 € por dia. A CheckPoint não se responsabiliza por objectos ou valores deixados dentro do veículo.";
  static termsConditionsTech =
    "O cliente autoriza os sintomas contratados e concorda com o estado do equipamento. O equipamento deverá ser levantado no prazo máximo de 72 horas após o nosso contacto ou passa a ser devida indemnização por espaço ocupado, no valor de 5€+IVA por dia. A Clickstop não se responsabiliza por objetos ou valores deixados com o equipamento (a não ser que esteja devidamente assinalado na folha de Pedido de Assistência). Qualquer defeito decorrente da má execução do contrato deverá sempre ser apresentado à Clickstop que se reserva o direito de proceder, por ela própria, à respetiva eliminação a que haja lugar. A responsabilidade da Clickstop por eventuais danos sofridos pelo cliente em virtude de defeitos decorrentes da execução do contrato não poderá, em caso algum, ser superior ao valor da reparação contratada, não compreendendo eventuais custos por danos ou perda de dados ou outras informações ou por perda ou danos no Software instalado. Dados provenientes do serviço de backup serão mantidos no servidor durante 15 dias de forma a proteger o cliente.";
  static termsLabels = {
    privacy: {
      generalTitle: "Política de privacidade",
      termsTitle: "Condições Gerais",
      message1: "A *companyname* (NIPC *vat*), adiante Empresa, está empenhada em proteger a privacidade de todos os seus clientes tendo, para o efeito, assumido a presente política de privacidade com o intuito de demonstrar e informar o seu compromisso de respeito pelos dados pessoais e adotado as melhores práticas que, nos termos da lei e dos regulamentos aplicáveis, devem ser observados no que diz respeito a técnicas de segurança e proteção dos dados pessoais. A Empresa é Responsável pelo Tratamento dos Dados para efeitos do Regulamento Geral da Proteção de Dados. A Acordo Certo 2, Unipessoal Lda, detentora da marca “Keymaster”, doravante assim designada com sede em Av. Dom Pedro I, nº275 R/C, 2750-786 Cascais, com o NIF 509 888 925, trata os dados de acordo com as instruções documentadas da Empresa sendo subcontratante para efeitos do Regulamento Geral da Proteção de Dados. \n \nNeste sentido, pede‐se que leia a Política de Privacidade que é adotada pela Empresa, pois a sua relação contratual com esta e/ou o seu acesso ao website https://www.keymaster.pt, domínio cuja propriedade pertence à Acordo Certo 2, Unipessoal Lda, através do qual disponibiliza os seus dados pessoais, implica o conhecimento e a aceitação expressa e prévia das condições constantes de tal Política de Privacidade, porque quando estabelece as referidas relações contratuais ou acede ao referido website está a autorizar a recolha e tratamento dos seus dados pessoais de acordo com as regras aqui definidas. \n \nOs dados são fornecidos à Keymaster pela Empresa, prestadora do serviço, que os recolhe dos seus clientes e por conta de quem os mesmos são tratados. \n \nA Keymaster esclarece que a simples navegação ou acesso ao seu website não implica, necessariamente, a recolha dos seus dados pessoais ou cookies. Não obstante, informa‐se que o website também utiliza cookies, pelo que dispõe de uma Política de Cookies que deverá, também, consultar. \n \nA Keymaster trata os dados apenas mediante as instruções documentadas da Empresa. Excetuam-se apenas os dados de login na aplicação ou no site, cuja responsabilidade pelo tratamento é diretamente da Keymaster. \n \n**Dados pessoais, titulares de dados pessoais e categorias de dados pessoais**\n \na) O que são dados pessoais? \nDados pessoais são qualquer informação, de qualquer natureza e independentemente do respetivo suporte (som ou imagem), relativa a uma pessoa singular identificada ou identificável. \n \nÉ considerada identificável uma pessoa singular que possa ser identificada direta ou indiretamente, em especial por referência a um identificador como, por exemplo, um nome, um número de identificação, dados de localização, identificadores por via eletrónica ou a um ou mais elementos específicos que permitam chegar à identificação dessa pessoa singular. \n \nb) Quem são os titulares dos dados pessoais? \n \nOs titulares dos dados pessoais são as pessoas singulares – clientes da Empresa e as pessoas que acedam ao website da Keymaster e que intervenham ou participem nas iniciativas desencadeadas pela Keymaster ou pela Empresa e que forneçam os seus dados pessoais para este efeito e que podem não ter qualquer relação contratual com a Keymaster. \n \nc) Que categoria de dados pessoais tratamos? \n \nConsulte aqui os dados que poderemos recolher por conta da Empresa: *client**item**work* \nPor conta da Keymaster são recolhidos os seguintes dados: nome abreviado, e-mail e telefone. \n \nO responsável pelo tratamento de dados é o encarregado de proteção de dados \nO responsável pela recolha e tratamento dos dados pessoais é a Empresa, sendo Subcontratante a Keymaster, que trata os dados por conta e no interesse da Empresa. \nQuanto aos dados de login na aplicação, e apenas quanto a estes, o responsável pela recolha e tratamento dos dados pessoais é a Keymaster. \n \n**Fundamento, finalidades e duração do tratamento de dados pessoais**\n \na) Fundamentos para a Empresa tratar os dados pessoais \n \na.1) Consentimento \n \nExiste consentimento quando o titular dos dados expressar o seu consentimento expresso ‐ por escrito - ou proceder a tal autorização mediante o acesso ao website da Empresa através da validação de uma opção – e se esse consentimento for livre, informado, específico e inequívoco; \n \nSão exemplos da necessidade de consentimento: a autorização para a Empresa enviar newsletters com mensagens sobre iniciativas que promova, enviar comunicações ou mensagens ou poder ceder os seus dados pessoais a terceiros; \n \nCom base no seu consentimento, iremos tratar os dados nos termos abaixo descritos. \n \na.2) Cumprimento de obrigação legal \n \nQuando o tratamento de dados pessoais seja necessário para o cumprimento de uma obrigação legal por parte da Keymaster ou da Empresa como as que decorrem da necessidade de cumprir notificações efetuadas por entidades policiais, judiciais e entidades reguladoras ou para o cumprimento de obrigações perante o fisco ou perante a segurança social ou para assegurar serviços de emergência ou para a celebração e acesso às prestações de seguradoras legalmente exigíveis (v.g. seguro de acidentes pessoais e/ou seguro de acidentes profissionais); \n \na.3) Interesse legítimo \n \nQuando o tratamento de dados pessoais corresponda a um interesse legítimo da Keymaster ou da Empresa como, por exemplo, a deteção de fraudes e quando os motivos para a utilização dos dados pessoais devam prevalecer sobre os direitos de proteção de dados do respetivo titular. \n \na.4) Consentimento por menores \n \nNo caso do tratamento de dados pessoais de menores, que possam estar sujeitos a consentimento prévio, tal consentimento só é válido se for efetuado por parte de que comprove ser detentor das responsabilidades parentais. \n \nb) Finalidades do tratamento dos dados pessoais \n \nO tratamento dos dados pessoais recolhidos por conta da Empresa é efetuado com as seguintes finalidades: \n \nb.1) Gestão \n \n* Manutenção de contactos; \n* Resposta a reclamações; \n \nb.2) Gestão Contabilística, Fiscal e Administrativa \n \n* Contabilidade e faturação; \n* Informação fiscal e à segurança social, quando for caso disso. \n \nb.3) Gestão de contencioso \n \n* Cobrança de judicial e extrajudicial de dívidas; \n* Intervenção noutros conflitos judiciais e extrajudiciais. \n \nb.4) Gestão de redes e sistema \n \n* Suporte e melhoria das redes e aplicações que suportam os serviços prestados; \n* Monitorização, melhoria e suporte dos serviços prestados. \n \nb.5) Cumprimento de obrigações legais \n \nResposta a entidades judiciais, de regulação, de supervisão, fiscais e de segurança social. \n \n \nO tratamento dos dados pessoais recolhidos por conta da Keymaster é efetuado com as seguintes finalidades: \n \nb.6) Controlo de segurança de informação \n \n* Gestão de acessos, logs; \n* Gestão de backups; \n* Gestão de incidentes de segurança. \n \nb.7) Para efeitos de divulgação de iniciativas e de informação \n \n* Divulgação das iniciativas promovidas pela Empresa ou por terceiros. \n \n**Categorias especiais de dados pessoais**\n \nEm certos casos, quando a Empresa desenvolva a sua atividade na área da saúde, poderá vir a tratar dados de saúde. A Keymaster limita-se a arquivar os mesmos nas suas plataformas e facultar a consulta ao cliente, sendo a recolha e os demais tratamentos de responsabilidade da Empresa. \n \nNestes casos, é solicitado o consentimento específico para o tratamento de dados sensíveis. \n \n**Prazos de tratamento dos dados pessoais**\n \nA Empresa conserva os seus dados pessoais conforme as finalidades para que os mesmos são tratados. \n \nA Empresa poderá manter outros dados pessoais por períodos superiores aos acima mencionados, seja com base no consentimento dos titulares dos dados, seja para assegurar deveres, direitos ou deveres relacionados com os contratos e as relações estabelecidas com os titulares dos dados pessoais, seja ainda porque têm interesses legítimos que o fundamentam, mas sempre pelo tempo estritamente necessário à realização das respetivas finalidades e de acordo com as orientações e decisões da CNPD. \n \nSão exemplo, os contactos para efeitos de informação e promoção das iniciativas promovidas pela Empresa e processos judiciais pelo prazo em que estes estiverem pendentes. \n \n**Forma e o momento da recolha dos dados pessoais**\n \nRecolhemos os dados pessoais de todos os que mantiverem relações contratuais com a Empresa com o intuito de serem informados sobre as iniciativas promovidas pela Empresa ou de nelas se inscreverem. \n \n**Direitos do titular dos dados pessoais**\n \nOs direitos dos titulares dos dados pessoais, são os seguintes: \na) Direito de acesso \nDireito a obter a confirmação de quais são os seus dados pessoais que estão a ser tratados e direito a obter informação sobre esses mesmos dados pessoais, nomeadamente, sobre quais as finalidades do tratamento e quais os prazos de conservação. \n \nb) Direito de retificação \nDireito a obter a retificação dos seus dados pessoais que se encontrem inexatos ou solicitar que os dados pessoais incompletos sejam completados, como por exemplo a morada, o NIF, o email, contactos telefónicos e outros. \n \nc) Direito ao apagamento dos dados ou direito a ser esquecido \nDireito a obter o apagamento dos seus dados pessoais, desde que não exista fundamento válido para a sua conservação, como, por exemplo, a necessidade de serem cumpridas obrigações legais de qualquer ordem, como a necessidade de preservar os dados para cumprimentos do dever de informação perante os tribunais, entidades policiais e a administração pública. \n \nd) Direito à portabilidade \nDireito de receber os dados que lhe digam respeito e que forneceu em formato digital de uso corrente e de leitura automática ou de solicitar a transmissão direta de tais dados para outra entidade que passe a ser o novo responsável pelos seus dados pessoais sempre que esta transmissão seja tecnicamente possível. \n \ne) Direito a retirar o consentimento e direito de oposição \nDireito de se opor ou retirar o seu consentimento, a qualquer momento, a um tratamento de dados, desde que não se verifiquem interesses legítimos que prevaleçam sobre os seus interesses, direitos e liberdades, como por exemplo a intervenção em processo judicial ou em processo de natureza fiscal. \n \nf) Direito de limitação \nDireito a solicitar a suspensão do tratamento dos seus dados pessoais ou que o âmbito do tratamento seja restrito a certas categorias de dados ou finalidades de tratamento e que essa limitação não colida com a necessidade de cumprimento de obrigações legais de qualquer ordem. \n \ng) Decisões automatizadas e definição de perfis \nA Empresa pode traçar o perfil dos seus clientes e utilizadores desde que esse tratamento seja necessário para cumprir obrigação legal ou decorram do consentimento do titular. \n \nSe o tratamento de dados pessoais, incluindo o tratamento para a definição de perfis, for exclusivamente automático, ou seja sem intervenção humana, e possa produzir efeitos na esfera jurídica ou afetar significativamente o titular dos dados pessoais, este tem o direito a não ficar sujeito a nenhuma decisão que se baseie nesse tratamento automático, salvo as exceções previstas na lei, e terá o direito a que a Empresa adote as medidas necessárias e adequadas para salvaguardar os seus direitos e legítimos interesses, incluindo o direito a que haja intervenção humana na tomada de decisão da Empresa e o direito de emitir a sua opinião e de contestar qualquer decisão tomada com base no tratamento automatizado de dados pessoais. \n \nh) Direito de reclamação \nO titular dos dados pessoais tem o direito de, em qualquer momento, apresentar reclamação à autoridade de controlo, CNPD ‐ Comissão Nacional de Proteção de Dados, ou à Empresa. \n \n**Exercício dos direitos pelo titular de dados**\n \nO exercício dos direitos pelo titular dos dados pessoais é gratuito, exceto se manifestamente infundado ou excessivo, caso em que poderá a Empresa cobrar taxa razoável que cubra os custos que implicou a análise e apreciação do exercício de tal direito. \n \nOs titulares dos dados pessoais podem exercer os direitos inerentes a esses dados pessoais através da apresentação de requerimento escrito, a apresentar pessoalmente, por via postal ou nas instalações da Empresa. O titular poderá ainda fazê-lo através do seguinte correio eletrónico: comunicacao@keymaster.pt, sendo que a Keymaster remeterá para a Empresa todos os pedidos para exercício de direitos que receber dos titulares dos dados. \n \nA Keymaster enviará à Empresa todos as notificações que receber dos titulares dos dados que sejam clientes finais quanto ao exercício dos respetivos direitos, ficando a Empresa responsável pela respetiva resposta. \nCaso a Empresa receba diretamente um pedido de exercício de direitos dos titulares dos dados, esta comunicará à Keymaster as ações que esta deverá desenvolver. \n \n**A transmissão de dados pessoais**\n \nOs dados pessoais podem ser transmitidos a terceiros para que estes os tratem em nome e por conta da Keymaster ou da Empresa, caso em que esta adotará as medidas adequadas a assegurar que tais terceiros são entidades reconhecidamente idóneas e que oferecem elevadas garantias de respeito pela proteção dos dados pessoais no cumprimento das normas legais e regulamentarmente aplicáveis e da presente política e privacidade. \nOs dados pessoais poderão ainda ser transmitidos a outros parceiros da Keymaster quando solicite os serviços dos mesmos. Poderá consultar a nossa lista de parceiros aqui: *companies*. \nQuando tal situação ocorrer, a Keymaster tomará as medidas adequadas a assegurar que a entidade que tenha acesso aos dados pessoais assumirá a obrigação de adotar as medidas técnicas e organizacionais necessárias de forma a proteger tais dados contra a sua destruição, acidental ou ilícita, a perda acidental, a alteração, a difusão ou o acesso não autorizado e contra qualquer outra forma de tratamento ilícito. \n \nOs dados pessoais só poderão ser transferidos para fora da União Europeia se tal transferência for requerida expressamente pelo seu titular. \n \n**Medidas processuais e técnicas de segurança**\n \nA Empresa e a Keymaster assumem o compromisso de garantir a segurança e proteção dos dados pessoais que recebe, tendo adotado as medidas técnicas e organizativas adequadas ao efeito, nomeadamente: \na)Proteção com passwords para o acesso aos dados pessoais; \nb)Restrição de entrada física nos locais onde os servidores que armazenam os dados pessoais se encontram; \nc)Restrição de entrada física aos locais onde se encontram os documentos em suporte de papel que contêm os dados pessoais dos colaboradores, fornecedores ou clientes; \nd) Firewalls. \n \nA Keymaster e a Empresa asseguram, mutuamente, que todas as pessoas que têm acesso aos dados se encontram abrangidas por um acordo de confidencialidade quanto aos mesmos. \n \nA Empresa comunica que as referidas medidas de segurança são revistas e atualizadas consoante as necessidades que se venham a verificar. \n \n**Violação de segurança dos dados**\n \nCaso, por algum motivo, se verifique uma violação da segurança que provoque, de modo acidental ou ilícito, a destruição, a perda, a alteração, a divulgação ou o acesso, não autorizados, aos dados pessoais a Keymaster comunicará sem demora justificada e, sempre que possível, até 72 horas após ter tido conhecimento da mesma e nos termos da legislação aplicável, tal facto às autoridades competentes e à Empresa. \n \nDa mesma forma a Empresa comunica a violação dos dados pessoais ao respetivo titular dos dados pessoais, nos termos da legislação aplicável. \n \n**Eliminação dos dados ou exportação**\n \nA Keymaster procederá ao apagamento definitivo dos dados 60 dias após a cessação da relação contratual entre as Partes. Nesse período, a Empresa poderá proceder à exportação dos dados, salvo se tal for impossível ao abrigo de disposição legal. \n \n**Alterações aos termos e condições**\n \nA Keymaster reserva‐se o direito de a qualquer altura proceder a reajustamentos ou alterações aos presentes, sendo essas alterações devidamente publicitadas no website https://www.keymaster.pt. \n \n",
    }
  }

  // Tasks
  static noDetails = "Sem Detalhes Disponíveis";
  static totalBudget = "Valor Total";
  static IVAValue = "(c/ IVA)";
  static noIVAValue = "(s/ IVA)";

  // Customer Support
  static customerSupport = {
    title: "Apoio ao Cliente",
    messagePlaceholder: "Deixe-nos a sua mensagem...",
    chooseSupportType: 'Escolha o "Apoio ao Cliente" desejado',
    chooseSupportPlaceholder: "Selecione uma opção...",
    appSupportLabel: (app) => "App $app".replace("$app", app),
    companySupportLabel: (company) => "Suporte $company".replace("$company", company),
    mandatoryTypeMessage: "Escolha por favor o tipo de suporte desejado",
  };

  // Modals
  static modal = {
    approvedBudget: {
      title: "Orçamento Aprovado! Obrigado",
    },
    modalLocation: {
      title: 'Permitir Localização',
      //text: 'Para desfrutar da melhor experiência possível na App Keymaster Cliente, poderá ser-lhe perguntado se permite disponibilizar a localização do seu dispositivo.'
      text: 'Partilhe a sua localização para ver os serviços mais perto de si!'
    }
  };

  // Gallery
  static galleryTitle = {
    desktop: "Fotos/Vídeos do Serviço",
    mobile: "Fotos/Vídeos",
  };
  static documentsTitle = "Ficheiros";
  static documentsByProvider = "Ficheiros adicionados pelo Prestador de Serviços";
  static documentsByCustomer = "Ficheiros adicionados pelo cliente";
  static galleryByProvider = "Fotos/vídeos adicionados pelo Prestador de Serviços";
  static galleryByCustomer = "Fotos/vídeos adicionados pelo cliente";
  static galleryUploadOptions = {
    title: "Como pretende adicionar o ficheiro?",
    photo: "Fotografia",
    video: "Vídeo",
    gallery: "Galeria",
    cancel: "Cancelar",
  };

  static cardCategoriaDetailsTitle = "Sintomas/Requisitos & Chat";
  static cardCategoriaDetailsTitleGroup = "Sintomas/Requisitos & Chat de Grupo";
  static cardPersonalNotesTitle = "As suas Notas Privadas";

  // Call To APP Store
  static AppStoreModal = {
    title: "Desfrute de toda a experiência Keymaster",
    message:
      "Instale agora a App Keymaster Cliente no seu dispositivo Android e usufrua de todas as vantagens que a App tem para lhe oferecer.",
    messageIOS:
      "Instale agora a App Keymaster Cliente no seu dispositivo Apple e usufrua de todas as vantagens que a App tem para lhe oferecer.",
    buttonLabel: "Ir à PlayStore",
    buttonLabelIOS: "Ir à AppStore",
    srcImage: "",
  };

  // Share Service
  static shareService = {
    text: "Acompanha o meu serviço em tempo real com o Keymaster: ",
    copyAsk: "Deseja partilhar o seu serviço?",
    copySuccess: "Endereço copiado com sucesso!",
    confirm: "Copiar Link",
    title: "Partilhar link para o seu Serviço.",
  };

  static shareMeeting = {
    text: "Partilhar link para Videochamada:",
    copyAsk: "Deseja partilhar a sua Videochamada?",
    copySuccess: "Endereço copiado com sucesso!",
    confirm: "Copiar Link",
    title: "Link para Videochamada.",
  };

  // Notifications
  static notifications = {
    title: {
      message: "Nova Mensagem",
      action: "Pendente",
      check: "Serviço Concluído!",
      internal: "Notas Pessoais",
      payment: "Disponível"
    },
    description: {
      check: "Aguardamos por si.",
      message: "ver agora",
      action: "Aprovação",
      internal: "ver agora",
      payment: "Pagamento"
    },
  };

  // Notifications List
  static notificationsList = {
    title: "Notificações Keymaster",
    clearAll: "Marcar todas lidas",
  };

  // Conta
  static deleteAccount = {
    confirmation: {
      title: "",
      message: (company) =>
        `Aqui pode apagar a sua conta de cliente da $company de forma definitiva. Deseja continuar?`.replace(
          "$company",
          company
        ),
      confirm: "Apagar a sua conta",
    },
    information: {
      title: (company) => `Conta de cliente de ${company} removida`,
      message: "",
    },
  };

  static linkToWork = "Ver serviço associado";
  static linkToSchedule = "Ver marcação associada";

  static payment = {
    title: "Pagamento",
    subtitle: (date) => "Efectue o pagamento até $1 para assegurar a sua marcação".replace("$1", date),
    description: (type, state) => {
      const method = PaymentService.convertTypeIntoMethod(type);
      return `Pagamento por ${PaymentMethodLabel[method]}: ${PaymentStateLabel[state]}`;
    },
    validation: "Pagamento com cartão em validação...",
    details: {
      entity: "Entidade:",
      reference: "Referência:",
      expiration: "Válido até:",
    },
    button: {
      continue: "Continuar Pagamento",
      cc: "Continuar Pagamento (Cartão)",
      newcc: "Escolher novo Cartão",
      mbway: "Continuar Pagamento (MB WAY)",
      mb: "Continuar Pagamento (Multibanco)"
    },
    billing: {
      validation: {
        empty: "Preencha por favor todos os campos de faturação. \nObrigado!",
        nif: Labels.profileInvalidNIF,
        zipCode: Labels.invalidZipCode,
      },
      saveButton: {
        general: "Guardar",
        client: "Atualizar dados do perfil"
      }
    },
    linkToWork: "Consultar pagamento",
    linkToSchedule: "Ver marcação associada",
  }
}
